import { createAsyncAction } from 'typesafe-actions';
import * as types from './skuUom.actionTypes';
import { UOM } from '@nimbly-technologies/nimbly-common';

export const fetchSkuUoms = createAsyncAction(
	types.FETCH_SKU_UOMS_REQUEST,
	types.FETCH_SKU_UOMS_SUCCESS,
	types.FETCH_SKU_UOMS_FAILURE,
)<undefined, UOM[], string>();
